import { lazy, Suspense } from "react";
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AnimatedRoutes from "./components/AnimatedRoutes/AnimatedRoutes";
import NavBar from "./components/Nav/NavBar";
const FooterB = lazy(() => import("./components/FooterB/FooterB"));

function App() {
  return (
    <Router>
        <NavBar />
      <AnimatedRoutes />
      <Suspense fallback={<></>}>
        <FooterB />
      </Suspense>
    </Router>
  );
}

export default App;
